import loadBasketModule from './modules/Basket.module';
import loadSessionModule from './modules/Session.module';
const loadBuyModule = () => ({
    hasRouter: true,
    modules: [loadSessionModule(), loadBasketModule()],
});
export default loadBuyModule;
